import { render, staticRenderFns } from "./SyncClientDialog.vue?vue&type=template&id=51f60d61&scoped=true"
import script from "./SyncClientDialog.vue?vue&type=script&lang=js"
export * from "./SyncClientDialog.vue?vue&type=script&lang=js"
import style0 from "./SyncClientDialog.vue?vue&type=style&index=0&id=51f60d61&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f60d61",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51f60d61')) {
      api.createRecord('51f60d61', component.options)
    } else {
      api.reload('51f60d61', component.options)
    }
    module.hot.accept("./SyncClientDialog.vue?vue&type=template&id=51f60d61&scoped=true", function () {
      api.rerender('51f60d61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/components/SyncClientDialog.vue"
export default component.exports